<div class="radiobutton-list" (keydown)="onListKeydown($event)">
<div class="radiobutton-list-item radio radiobutton-inline" [ngClass]="{'nested':item.isNested==true}" *ngFor="let item of items; let i = index" (click)="handleClick($event,item)">
  <input type="radio" id="inlineRadioButton{{i}}" value="option{{i}}" [checked]="item.isChecked" (click)="handleClick($event,item);false">
  <label for="inlineRadioButton{{i}}" title="{{item.display}}"> {{item.display}} <span *ngIf="item.isRollup"> ({{"plan.details.rollup" | translate}})</span></label>
</div>
</div>
